/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest,
  TelegramTransactionsUserControllerCreateAndroidPaymentMutationResponse,
  TelegramTransactionsUserControllerCreateAndroidPayment400,
  TelegramTransactionsUserControllerCreateAndroidPayment401,
  TelegramTransactionsUserControllerCreateAndroidPayment404,
} from '../types/TelegramTransactionsUserControllerCreateAndroidPayment.ts';

function getTelegramTransactionsUserCreateAndroidPaymentUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/transactions/android` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/android}
 */
export async function telegramTransactionsUserCreateAndroidPayment(
  data: TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest,
  config: Partial<RequestConfig<TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramTransactionsUserControllerCreateAndroidPaymentMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerCreateAndroidPayment400
      | TelegramTransactionsUserControllerCreateAndroidPayment401
      | TelegramTransactionsUserControllerCreateAndroidPayment404
    >,
    TelegramTransactionsUserControllerCreateAndroidPaymentMutationRequest
  >({
    method: 'POST',
    url: getTelegramTransactionsUserCreateAndroidPaymentUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
